const APIURL = "https://juanodelprado-001-site12.qtempurl.com/"

export {APIURL}